import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "m12 1c-6.07513 0-11 4.92487-11 11 0 6.0751 4.92487 11 11 11 6.0751 0 11-4.9249 11-11 0-6.07513-4.9249-11-11-11zm1 7c0-.55228-.4477-1-1-1s-1 .44772-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1zm-1 7c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z",
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }